/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.1",
  "gitBuildTime": "2026-09-23T21:05:05.873Z",
  "gitBuildVersion": "2.9.1",
  "gitCommitId": "449b493",
  "gitCommitIdFull": "449b493a4a36b530014cc059dd8f1d3710e7f7fa",
  "gitCommitTime": "2026-09-23T21:03:33.000Z",
  "version": "2.9.1-2026-09-23T21:03:33.000Z-(449b493)"
};
